import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeRequests } from '../actions';
import RequestsPanel from '../components/RequestsPanel';
import ReviewActions from '../components/ReviewActions';

export default {
  ...tabTemplate('review-requests', RequestsPanel, matchSingleUrl(['review']), ReviewActions),
  ...tabCloser('closeRequestsTab', closeRequests),
  ...tabIcons('thumbs up'),
  access: ({ requests }) => requests.review,
  componentState: ({ url }) => categoryTab(url, 'review'),
  order: 505,
};
